export default __webpack_public_path__ + "static/media/chevron-right-outline-16px.72457846.svg";